import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const Wrapper = styled.div` 
    width: 100%;
    height: auto;
    max-width: 1100px;
    padding: 0 1.5rem 1.5rem;

    gap: 1.5rem;
    display: flex;
    align-items: center;
    flex-direction: column;

    background-color: #FFFF;

    >div{
        width: 100%;
    }

    @media (max-width: 760px) {
        padding: 0 1rem;

        gap: 1rem;
    }

    @media (max-width: 479px) {
        padding: 0;

        gap: 0;
    }
`;

export const ContentPage = styled.div`
    width: 100%;
    height: auto;
    padding: 1.5rem 0 0;

    gap: 1.5rem;
    display: flex;
    flex-direction: row;
    justify-content: center;

    @media (max-width: 760px) {
        gap: 1rem;
    }

    @media (max-width: 479px) {
        padding: 1rem;
    }
`

export const SecontContentPage = styled(ContentPage)`
    padding: 0;

    @media (max-width: 479px) {
        padding: 1rem 1rem 0;
    }
`;

export const ThirdyContentPage = styled(ContentPage)`
    padding: 0;

    @media (max-width: 1068px) {
        align-items: center;
        flex-direction: column;
    }

    @media (max-width: 479px) {
        padding: 1rem 1rem 0;

        gap: 1rem;
    }
`;

export const MapView = styled.div`
    width: 100%;
    height: auto;
`;

export const Background = styled.div`
    width: 100%;
    padding: 1rem;
    max-width: 64.75rem;

    display: flex;
    border-radius: 0.75rem;
    background-color: #f8f8f9;

    @media (max-width: 1068px) {
        >div{
            max-width: 100%;

            gap: 1rem;
            align-items: center;
            flex-direction: column;

            >div{
                width: 100%;
            }
        }
    }

    @media (max-width: 760px) {
        max-width: 100%;
        padding: 0 1rem 1rem;

        gap: 0;

        >div:nth-of-type(1){
            padding: 1rem 0;
        }
    }
`;